import useContentRefLayout from './useContentRefLayout';

export default useContentRefLayout;
